"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pesquisaSatisfacaoConstants = /** @class */ (function () {
    function pesquisaSatisfacaoConstants() {
    }
    pesquisaSatisfacaoConstants.pesquisaSatisfacao = [
        "Nenhuma",
        "Classificação de atendimento",
        "Pesquisa externa"
    ];
    pesquisaSatisfacaoConstants.nenhuma = "Nenhuma";
    pesquisaSatisfacaoConstants.classificacaoAtendimento = "Classificação de atendimento";
    pesquisaSatisfacaoConstants.pesquisaExterna = "Pesquisa externa";
    pesquisaSatisfacaoConstants.pesquisaCustomizada = "Pesquisa customizada";
    return pesquisaSatisfacaoConstants;
}());
exports.default = pesquisaSatisfacaoConstants;
//# sourceMappingURL=pesquisa-satisfacao.js.map